import type { ReactNode } from 'react';

interface RequiredLabelProps {
  children: ReactNode;
  required?: boolean;
}

export const RequiredLabel = ({
  children,
  required = true,
}: RequiredLabelProps) => (
  <>
    {children}
    {required && (
      <span aria-hidden="true" style={{ color: 'var(--colors-error, red)' }}>
        {' '}
        *
      </span>
    )}
  </>
);
